import {Observable, Subject} from '../../../../node_modules/rxjs';
import {Headers, Http, RequestOptions, URLSearchParams} from '@angular/http';
import {Injectable} from '@angular/core';
import {OcrFileinfo} from '../../domain/model/common/file/ocr-file-info.class';
import {UserImpersonationService} from '../../domain/model/user/user-impersonation.service';
import {Subscription} from 'rxjs/Subscription';
import {StompService} from '@stomp/ng2-stompjs';
import {AuthService} from '../security/authorization/auth.service';
import {Message} from '@stomp/stompjs';

export const IMPERSONATED_USER_REMOTE_PARAM = 'impersonatedUserRemote';

@Injectable()
export class OcrService {

    readonly subscriptions: Subscription[] = [];
    public taskCompleted$: Subject<string>;

    private readonly baseUrl: string;
    private readonly baseOptions = new RequestOptions({
        headers: new Headers({'Content-Type': 'application/json'})
    });

    constructor(readonly http: Http, readonly impersonationService: UserImpersonationService,
                readonly _stompService: StompService, readonly _authService: AuthService) {
        this.baseUrl = `${process.env.OCR_SERVICE_BASE_URI}/api/ocr`;

        this.taskCompleted$ = new Subject<string>();
        this.subscriptions.forEach(it => it.unsubscribe());
        this.subscriptions = [];
        this.subscriptions.push(this._authService.user$.subscribe(user => {
            if (user) {
                let remoteId = user.id.substr(user.id.lastIndexOf('/') + 1);
                this._stompService.subscribe(`/user/${remoteId}/topic/file-processing-completed`).map((message: Message) => {
                    return message.body;
                }).subscribe((msg_body: string) => {
                    this.taskCompleted$.next(msg_body);
                });
            }
        }));
    }

    list<OcrFileInfo>(): Observable<OcrFileinfo[]> {
        return this.http.get(`${this.baseUrl}/me/files`, this.options()).map(res => (res.text().length ? res.json() : []).map(e => new OcrFileinfo(e)));
    }

    file<OcrFileInfo>(id: string): Observable<OcrFileinfo> {
        return this.http.get(`${this.baseUrl}/me/files/${id}`, this.options()).map(res => {
            return res.text().length ? new OcrFileinfo(res.json()) : undefined;
        });
    }

    fileContent<String>(id: string): Observable<string> {
        return this.http.get(`${this.baseUrl}/me/files/${id}/content`, this.options()).map(res => {
            return res.text().length ? res.text() : undefined;
        });
    }

    private options() {
        let params = new URLSearchParams();

        const impersonatedUserRemoteId = this.impersonationService.impersonatedUserRemoteId;
        if (impersonatedUserRemoteId && this.impersonationService.isImpersonationAllowedOnPage) params.append(IMPERSONATED_USER_REMOTE_PARAM, impersonatedUserRemoteId);

        return this.baseOptions.merge({search: params});
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/ocr/ocr.service.ts